import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    hidden: true,
    component: () => import("@/views/Login"),
  },

  {
    path: "/",
    component: Layout,
    hidden: true,
    redirect: "/TradingBots",
  },

  {
    path: "/TradingBots",
    name: "TradingBots",
    component: Layout,
    meta: {
      icon: "el-icon-s-shop",
      title: "AI 交易机器人",
    },
    children: [
      {
        path: "",
        name: "TradingBots",
        component: () => import("@/views/TradingBots"),
      },
    ],
  },

  {
    path: "/AIEngines",
    name: "AIEngines",
    component: Layout,
    meta: {
      icon: "el-icon-s-shop",
      title: "AI 引擎",
    },
    children: [
      {
        path: "",
        name: "AIEngines",
        component: () => import("@/views/AIEngines"),
      },
    ],
  },

  {
    path: "/Exchanges",
    name: "Exchanges",
    component: Layout,
    meta: {
      icon: "el-icon-s-shop",
      title: "交易所管理",
    },
    children: [
      {
        path: "",
        name: "Exchanges",
        component: () => import("@/views/Exchanges"),
      },
    ],
  },
  {
    path: "/Signals",
    name: "Signals",
    component: Layout,
    meta: {
      icon: "el-icon-s-shop",
      title: "交易信号管理",
    },
    children: [
      {
        path: "",
        name: "Signals",
        component: () => import("@/views/Signals"),
      },
    ],
  },

  {
    path: "/Notifications",
    name: "Notifications",
    component: Layout,
    meta: {
      icon: "el-icon-s-message",
      title: "消息通知管理",
    },
    children: [
      {
        path: "",
        name: "Notifications",
        component: () => import("@/views/Notifications"),
      },
    ],
  },

  // {
  //   path: "/Billing",
  //   name: "Billing",
  //   component: Layout,
  //   meta: {
  //     icon: "el-icon-s-shop",
  //     title: "账单",
  //   },
  //   children: [
  //     {
  //       path: "",
  //       name: "Billing",
  //       component: () => import("@/views/Billing"),
  //     },
  //   ],
  // },

  {
    path: "/404",
    hidden: true,
    component: () => import("@/views/404"),
  },
  // 所有未定义路由，全部重定向到404页，必须放在最后
  {
    path: "*",
    hidden: true,
    redirect: "/404",
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
